import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { IconButton, Menu, MenuItem } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import CommonDataTable from '../../../components/CommonDataTable';

const rawColumns = [
  { field: 'channelId', headerName: 'Channel ID', width: 180 },
  { field: 'channelName', headerName: 'Channel Name', width: 180 },
  { field: 'channelType', headerName: 'Channel Type', width: 180 },
  { field: 'channelLink', headerName: 'Channel Link', width: 180 },
  { field: 'channelAPIs', headerName: 'Channel APIs' },
  
];
export default function ChannelLedgerList({ onCreateClick, channels,onView,onEdit }) {
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [menuRow, setMenuRow] = useState(null);
  const [tableRows, setTableRows] = useState([]);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);

  // ----------------- Update table when channels prop changes -----------------
  useEffect(() => {
    if (channels?.length) {
      // Transform channels to match your rawColumns
      const formattedChannels = channels.map(channel => ({
        id: channel._id, // for DataGrid
        channelId: channel.channel_Id,
        channelName: channel.channel_Name,
        channelType: channel.channel_Type,
        channelLink: channel.channel_Link,
        channelAPIs: channel.api_url
          ?.map(api => `${api.type}: ${api.link}`)
          .join(", ") || "",
          __original: channel
      }));

      setTableRows(formattedChannels);
      setTotalCount(formattedChannels.length);
    }
  }, [channels]);

  // ----------------- Menu handling -----------------
  const handleOpenMenu = (e, row) => {
    e.stopPropagation();
    setMenuAnchorEl(e.currentTarget);
    setMenuRow(row);
  };
  const handleCloseMenu = () => {
    setMenuAnchorEl(null);
    setMenuRow(null);
  };

  const actionColumn = {
    field: "__actions",
    headerName: "",
    width: 100,
    sortable: false,
    filterable: false,
    disableColumnMenu: true,
    renderCell: (params) => (
      <IconButton
        size="small"
        onClick={(e) => handleOpenMenu(e, params.row)}
        aria-label="row actions"
      >
        <MoreVertIcon fontSize="small" />
      </IconButton>
    ),
  };

  const allPossibleColumns = useMemo(() => [actionColumn, ...rawColumns], []);
  const initialVisible = useMemo(
    () => allPossibleColumns.map((c) => c.field),
    [allPossibleColumns]
  );

  return (
    <>
      <CommonDataTable
        allPossibleColumns={allPossibleColumns}
        initialVisible={initialVisible}
        initialRows={tableRows}
        height={520}
        rowsPerPageOptions={[10, 25, 50, 100]}
        exportImportPath="InventoryLedger"
        forItems
        showCreateButton={true}
        createButtonText="Create New"
        createButtonIcon="bi-plus-lg"
        onCreateClick={onCreateClick}
        createButtonVariant="contained"
        createButtonColor="primary"
        page={page}
        pageSize={pageSize}
        rowCount={totalCount}
        onPageChange={(newPage) => setPage(newPage)}
        onPageSizeChange={(newSize) => {
          setPageSize(newSize);
          setPage(0);
        }}
      />

    <Menu open={!!menuAnchorEl} anchorEl={menuAnchorEl} onClose={handleCloseMenu}>
                   <MenuItem onClick={() => onView(menuRow.__original)}>
                       <i className="bi bi-eye me-2" /> View
                   </MenuItem>
                   <MenuItem onClick={() => onEdit(menuRow.__original)}>
                       <i className="bi bi-pencil me-2" /> Edit
                   </MenuItem>
               </Menu>
    </>
  );
}
